// extracted by mini-css-extract-plugin
export var container = "_4q-0";
export var icon = "_4q-1";
export var text = "_4q-2";